import React from 'react';
import BackgroundJobsList from './BackgroundJobsList';

const BackgroundJobsTableContainer = ({
    ...props
}) => {

    return (
        <div >
            <div >
                <BackgroundJobsList />
            </div>
        </div>
    );
};

export default BackgroundJobsTableContainer;
